import React, { useEffect } from 'react';
import { ApplicationEvent } from '../../../models/analytics';
import { AppStoreCredentialsError, AppStoreGeneralError } from '../../../stores/app-state-errors';
import { useAnalytics } from '../../Analytics/AnalyticsProvider';
import { LoadingOverlay } from '../LoadingOverlay/LoadingOverlay';

export type ExecutorProps = {
  execute: () => void;
  error: AppStoreGeneralError | AppStoreCredentialsError;
};

export const Executor = ({ execute, error }: ExecutorProps) => {
  const { tinklinkAnalytics } = useAnalytics();
  const { errorReason, errorStatus } = error;

  useEffect(() => {
    tinklinkAnalytics.update({ errorReason: `${errorStatus}:${errorReason}` });
    tinklinkAnalytics.sendApplicationEvent(ApplicationEvent.REDIRECT_EXECUTOR);
  }, [errorReason, errorStatus, tinklinkAnalytics]);

  useEffect(() => {
    execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingOverlay />;
};
